<script lang="ts">
    
    import { AccordionItem } from "sveltestrap";
    import type { Section } from "../../Model/Section";
    import Watch from "../Watch.svelte";
    import Editable from "./Editable.svelte";
    import QuestionPreview from "./QuestionPreview.svelte";

    export let section: Section;
    export let position: number;

</script>

<AccordionItem>
    <h5 class="m-0" slot="header">
        {position}.- <Editable store={section.name} />
    </h5>
    <Watch store={section.questionsReadable} let:value={questions}>
        {#each questions as question}
            <QuestionPreview {question} />
        {/each}
    </Watch>
</AccordionItem>

